import HealthClaimApproval from './HealthClaimApproval'

export default HealthClaimApproval
